module.exports = __webpack_public_path__ + "static/media/Amazon.1a42e862.svg";